<template>
<div :class="variation">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        variation: {
            type: String,
            default: 'dropdown',
        }
    }
}
</script>